<template>
    <div>
        <PageHeader :title="t('vacancy')" class="mb-6 lg:mb-10" />
        <div class="my-container mb-[100px]">
            <UAccordion :items="filteredItems" class="faq-accordion" :ui="accConfig">
                <template #default="{ item, index, open }">

                    <button class="flex items-center">
                        <span class="text-semibold text-[20px]/[24px] lg:text-[20px]/[30px]">
                            {{ item.title }}
                        </span>

                        <div class="ml-auto rounded-full border-2 aspect-square	">
                            <UIcon name="bi:plus"
                                class="ms-auto transform transition-transform duration-200 block md:hidden"
                                :class="[open && 'rotate-45']" size="20" />
                            <UIcon name="bi:plus"
                                class="ms-auto transform transition-transform duration-200 hidden md:block"
                                :class="[open && 'rotate-45']" size="36" />
                        </div>

                    </button>
                </template>
                <template #item="{ item }">
                    <div>
                        <div v-html="item.body" class="body-content font-normal text-[14px]/[17px]"></div>
                        <button @click="openResumeModal(item)"
                            class="text-black hover:text-white py-3 px-8 bg-transparent hover:bg-my-green rounded-full border-2 border-my-green inter font-semibold">
                            {{ t('sendResume') }}</button>
                    </div>
                </template>
            </UAccordion>
            <UModal v-model="modal">
                <form class="p-5 bg-blue-dark-950 rounded-2xl" @submit.prevent="sendResume">
                    <h2 class="text-center mb-2 text-white text-[24px] relative">
                        {{ t('sendResume') }}
                        <Icon class="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer"
                            name="ri:close-large-fill" @click="modal = false"></Icon>
                    </h2>
                    <label for="ticket" class="mb-6 block">
                        <div class="text-white mb-2 text-[14px]/[17px] inter">
                            <span class="required">{{ t('Имя') }}</span>
                        </div>
                        <input id="ticket" type="text"
                            class="w-full p-3 rounded-xl placeholder-gray-text outline-0 inter"
                            :placeholder="t('enterYourName')" required v-model="form.name">
                    </label>
                    <label for="ticket" class="mb-6 block">
                        <div class="text-white mb-2 text-[14px]/[17px] inter">
                            <span class="required"> {{ t('phoneNumber') }}
                            </span>
                        </div>
                        <input id="ticket" type="tel"
                            class="w-full p-3 rounded-xl placeholder-gray-text outline-0 inter"
                            :placeholder="t('enterPhone')" required v-model="form.phone">
                    </label>
                    <label for="ticket" class="mb-6 block">
                        <div class="text-white mb-2 text-[14px]/[17px] inter">
                            <span class=""> Email
                            </span>
                        </div>
                        <input id="ticket" type="tel"
                            class="w-full p-3 rounded-xl placeholder-gray-text outline-0 inter"
                            :placeholder="t('enterEmail')" v-model="form.email">
                    </label>
                    <div class="custom-file-input">
                        <button type="button" @click="resumeInput.click()"
                            class="text-white w-full mb-4 py-3 px-8 bg-transparent hover:bg-my-green rounded-full border-2 border-my-green inter font-semibold">
                            {{ form.resume ? form.resume.name : t('addCV') }}
                        </button>
                        <input type="file" id="fileInput" hidden ref="resumeInput" @change="handleResume"
                            accept="application/pdf" />
                    </div>
                    <button type="submit"
                        class="py-4 px-6 bg-my-green mx-auto block rounded-3xl text-white text-[14px]/[16px] inter transition-shadow button-green">
                        {{ t('send') }}
                    </button>
                </form>
            </UModal>
        </div>
    </div>
</template>

<script setup>
import { useAccordionConfig } from '~/composables/useAccordionConfig';
const toast = useToast()
const accConfig = useAccordionConfig()
const route = useRoute();
const rc = useRuntimeConfig();
const { locale, t } = useI18n();
const headers = computed(() => ({
    lang: locale.value
}))
const data = await $fetch(rc.public.api + `/api/vacancies`, {
    headers: headers.value
})
const items = ref(data.data.vacancies)
const filteredItems = computed(() => items.value.filter(el => el.is_active === 1))

const modal = ref(false)
const resumeInput = ref()
const currentVacancy = ref()
const form = ref({
    name: '',
    phone: '',
    email: '',
    resume: ''
})
function openResumeModal(v) {
    currentVacancy.value = v;
    modal.value = true

}
function handleResume(e) {
    form.value.resume = e.target.files[0]
    console.log(e.target.files[0])
}

async function sendResume() {
    if (!form.value.resume) {
        console.log('error')
        return
    }
    try {
        const body = new FormData();
        body.append('file', form.value.resume);
        body.append('vacancy_slug', currentVacancy.value.slug);
        body.append('name', form.value.name)
        body.append('email', form.value.email)
        body.append('phone', form.value.phone)
        const res = await $fetch(rc.public.api + '/api/upload-resume', {
            method: 'POST',
            body,
            headers: headers.value
        })
        toast.add({
            title: res.data.message,
        })
        modal.value = false;
        form.value = {
            name: '',
            phone: '',
            email: '',
            resume: ''
        }
    } catch (error) {
        toast.add({
            title: error?.message,
            color: 'red'
        })
    }
}

useHead({
    title:t('vacancy')
})
</script>

<style lang="scss">
.body-content {
    font-family: Inter;

    & p {
        margin-bottom: 8px;
    }

    & ul {
        list-style-type: disc;
        list-style-position: inside;

        & li {
            margin-bottom: 8px;
            margin-left: 4px;
        }
    }
}
</style>